const GameState = {
  playerXwins: 0,
  playerOwins: 1,
  draw: 3,
  inProgress: 4,
};

export default GameState;
